module.exports = __webpack_public_path__ + "static/media/bgDoor2.e3ee3822.mp3";